import { render, staticRenderFns } from "./OuttripeurOuttripList.vue?vue&type=template&id=f2a26970&scoped=true&"
import script from "./OuttripeurOuttripList.vue?vue&type=script&lang=js&"
export * from "./OuttripeurOuttripList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2a26970",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VList } from 'vuetify/lib/components/VList';
installComponents(component, {VAlert,VList})
